"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useOverflow = void 0;
var _lodash = _interopRequireDefault(require("lodash.debounce"));
var _react = require("react");
const useOverflow = ({
  ref
}) => {
  const checkOverflow = (0, _react.useCallback)(() => {
    if (ref.current) {
      return ref.current.scrollHeight > ref.current.clientHeight;
    }
    return false;
  }, [ref]);
  const subscribe = (0, _react.useCallback)(callback => {
    const debouncedCallback = (0, _lodash.default)(callback, 100);
    window.addEventListener('resize', debouncedCallback);
    return () => {
      window.removeEventListener('resize', debouncedCallback);
      debouncedCallback.cancel();
    };
  }, []);
  const isOverflow = (0, _react.useSyncExternalStore)(subscribe, checkOverflow, checkOverflow);
  return {
    isOverflow
  };
};
exports.useOverflow = useOverflow;
//# sourceMappingURL=useOverflow.js.map